import script from "./appMain.vue?vue&type=script&setup=true&name=appMain&lang=js"
export * from "./appMain.vue?vue&type=script&setup=true&name=appMain&lang=js"

import "./appMain.vue?vue&type=style&index=0&id=6b3903c7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3903c7"]])

export default __exports__